import { createConfirmation } from "react-confirm";
import EditIngredientDialog from "./EditIngredientDialog";

export const showEditIngredientDialog = createConfirmation(EditIngredientDialog);
